import { z } from 'zod';

import { GuardianCodeSchema } from '../guardian-code/guardian-code';
import { GuardianLabelSchema } from '../guardian-label/guardian-label';

/**
 * Redeem a code and become somebody's guardian.
 *
 * `code` is parsed through {@link GuardianCodeSchema}, which **normalizes as it
 * validates** — so the service hashes exactly what the schema produced and a
 * lookup can never miss because the wali typed the hyphens, used lower case, or
 * typed the `O` he could see for the `0` the alphabet actually emits.
 *
 * `wardLabel` is asked for **here**, at the one moment the guardian is certainly
 * present and certainly knows who he is doing this for. Collecting it later
 * would mean a wards list that starts as uuids, and collecting it never would
 * mean it stays that way — see `GuardianLabelSchema` for why this is the answer
 * rather than resolving her profile.
 *
 * `.strict()` (N7).
 */
export const GuardianInviteAcceptSchema = z
  .object({
    code: GuardianCodeSchema,
    wardLabel: GuardianLabelSchema,
  })
  .strict();

export type GuardianInviteAccept = z.infer<typeof GuardianInviteAcceptSchema>;
